import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onStartClick?: () => void;
}

const Header = ({ onStartClick }: HeaderProps) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-lg mx-auto px-5 py-3 flex items-center justify-between">
        <span
          className="text-[#1a1a2e] font-bold tracking-wide text-base cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
          onClick={() => navigate('/')}
        >
          16タイプ診断
        </span>
        <button
          onClick={() => navigate('/quiz')}
          className="text-white text-xs px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-all duration-300 font-medium"
          style={{
            background: '#1a1a2e',
            minHeight: '40px',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
          }}
        >
          診断スタート
        </button>
      </div>
    </header>
  );
};

export default Header;
